import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ArrowLeft } from 'react-feather';
import { Spinner } from 'ui';
import Pagination from 'components/shared/pagination';
import { setParamsFromObject } from 'utils/url';
import { routes } from 'constants/config';
import useFetch from 'components/shared/hooks/useFetch';
import GradingStationList from './GradingStationList';

const GradingStationIndividualPageContainer = props => {
  const { history, currentUser, ziggeoApiKey } = props;
  const [page, setPage] = useState(1);
  const [progresses, setProgresses] = useState([]);
  const [totalPages, setTotalPages] = useState(2);
  const [gradableName, setGradableName] = useState('');

  const gradableId = parseInt(props.match.params.gradableId, 10);
  const { gradableType } = props.match.params;

  const url = () => {
    if (gradableType === 'lesson') {
      return setParamsFromObject(routes.GRADES.LESSON_PROGRESSES(gradableId), {
        page,
      });
    }
    if (gradableType === 'user') {
      return setParamsFromObject(routes.GRADES.USER_PROGRESSES(gradableId), {
        page,
      });
    }
    if (gradableType === 'group') {
      return setParamsFromObject(routes.GRADES.GROUP_PROGRESSES(gradableId), {
        page,
      });
    }
    if (gradableType === 'long-waiting') {
      return routes.GRADES.LONG_WAITING_PROGRESS(gradableId);
    }
    return setParamsFromObject(routes.GRADES.INDEX(), {
      gradableId,
      gradableType,
      page,
    });
  };

  const { data = {}, error, loading } = useFetch(url());
  const { stalenessThreshold } = data;

  useEffect(() => {
    // for long waiting it comes back as progress instead of progresses
    if (data.progress) {
      setProgresses([data.progress]);
      setTotalPages(1);
    }
    if (data.progresses) {
      setProgresses(data.progresses);
      if (page >= totalPages - 1) {
        setTotalPages(data.progresses.length >= data.perPage ? page + 1 : page);
      }
    }
    setGradableName(data.gradableName);
  }, [
    data.perPage,
    data.progress,
    data.progresses,
    data.gradableName,
    page,
    totalPages,
    gradableName,
  ]);

  if (error) {
    throw new Error(
      'Error fetching content for individual grading station page.',
    );
  }

  if (loading) {
    return (
      <div className="d-f jc-c ai-c p-32 mt-32 bg-white Table-body">
        <Spinner />
      </div>
    );
  }

  if (!progresses) {
    return (
      <div className="ff-ss blank_slate blank_slate--padded">
        <h2 className="ff-ss">{t('grades.blank_slate.title')}</h2>
        <p>{t('grades.blank_slate.description')}</p>
      </div>
    );
  }
  const hasProgresses = progresses.length > 0;

  const markProgressGraded = itemGraded => () => {
    const newProgresses = progresses.filter(p => p.id !== itemGraded);
    setProgresses(newProgresses);
  };

  const gradableTypeTranslation = () => {
    switch (gradableType) {
      case 'lesson':
        return t('lessons.filter_name');
      case 'user':
        return t('users.filter_name');
      case 'group':
        return t('grades.group_filter');
      default:
        return '';
    }
  };
  const displayPagination =
    (hasProgresses || page > 1) && gradableType !== 'long-waiting';
  return (
    <div>
      <div className="PanelHeader">
        <h1 className="PanelHeader-title ff-ss">{t('grades.title')}</h1>
      </div>
      <button
        type="button"
        onClick={() => history.goBack()}
        className="u-linkBtn ff-ss fz-16 ai-c d-f"
      >
        <ArrowLeft className="mr-12" size={16} />
        {gradableType === 'long-waiting'
          ? t('grades.navigation_back_long_waiting')
          : t('grades.navigation_back', {
              type: gradableTypeTranslation(),
            })}
      </button>
      <GradingStationList
        hasProgresses={hasProgresses}
        progresses={progresses}
        loading={loading}
        filtersLoading={false}
        gradableType={gradableType}
        currentGradableName={gradableName}
        currentGradableOptions={[]}
        currentUser={currentUser.name}
        stalenessThreshold={stalenessThreshold}
        markProgressGraded={markProgressGraded}
        ziggeoApiKey={ziggeoApiKey}
      />
      {displayPagination && (
        <div className="Pagination-panelFooter">
          <Pagination
            pages={totalPages}
            selected={page}
            pageSelectCallback={setPage}
          />
        </div>
      )}
    </div>
  );
};

GradingStationIndividualPageContainer.propTypes = {
  currentUser: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.number,
  }),
  gradableType: PropTypes.string,
  params: PropTypes.shape({
    set: PropTypes.func,
  }),
};

export default GradingStationIndividualPageContainer;
